import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import { incomeCoins } from '@/assets/images/offer';
import styles from './OtherIncomeBanner.module.scss';

interface OtherIncomeBannerProps {
  trackingId: string;
  onClick: () => void;
}

export function OtherIncomeBanner({ trackingId, onClick }: OtherIncomeBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.text}>
        <p className={styles.title}>Ai alte venituri?</p>
        <Button
          trackingId={trackingId}
          variant="text"
          size="xsmall"
          text="Încarcă dovada veniturilor"
          rightIcon={<Icon name="arrow-right" />}
          onClick={onClick}
          className={styles.button}
        />
      </div>
      <div className={styles.visual} aria-hidden>
        <img src={incomeCoins} alt="" width={72} height={72} className={styles.coins} />
      </div>
    </div>
  );
}
